// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24Wqz","colMin":"styles_colMin__2j02S"};